<div fxLayoutAlign="center center">
  <form #fProfile="ngForm" (ngSubmit)="onSubmit(fProfile.value)" [hidden]="disableForm">
    <mat-card fxFlex>
      <mat-card-header fxLayoutAlign="space-between center" style="padding-bottom: 16px;">
        <mat-card-title fxLayoutGap="8px" role="heading" aria-level="1">
          {{ userId ? "Edit User (Status: " + userProfile.account_status + ")" : fieldTexts.headerText }}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutAlign="space-around center" fxLayoutGap="8px grid">
          <mat-form-field matTooltip="{{fieldTexts.prefixToolTip}}" fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" class=""
            floatLabel="always">
            <mat-label>Prefix</mat-label>
            <input matInput type="text" name="prefix" [ngModel]="userProfile.prefix" [maxlength]="UserMaxLen.prefix">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>First Name</mat-label>
            <input matInput type="text" name="firstName" [ngModel]="userProfile.first_Name" required
              [maxlength]="UserMaxLen.first">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Middle Initial</mat-label>
            <input matInput type="text" name="middle_initial" [ngModel]="userProfile.middle_initial"
              [maxlength]="UserMaxLen.middle_initial">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Last Name</mat-label>
            <input matInput type="text" name="lastName" [ngModel]="userProfile.last_Name" required
              [maxlength]="UserMaxLen.last_Name">
          </mat-form-field>
          <mat-form-field matTooltip="{{fieldTexts.suffixToolTip}}" fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Suffix</mat-label>
            <input matInput type="text" name="suffix" [ngModel]="userProfile.suffix" [maxlength]="UserMaxLen.suffix">
          </mat-form-field>
          <mat-form-field matTooltip="{{fieldTexts.emailToolTip}}" *ngIf="register" fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline"
            floatLabel="always">
            <mat-label>Email Address</mat-label>
            <input matInput type="email" #email="ngModel" name="email" [ngModel]="userProfile.email"
              appEmailExist required [maxlength]="UserMaxLen.email">
            <mat-error *ngIf="email.invalid && email.touched && email.dirty && email.errors?.['exists']">Email already
              exists</mat-error>
            <mat-error
              *ngIf="email.invalid && email.touched && email.dirty && email.errors?.['error']">{{email.errors?.['error']}}</mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="!register" fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline"
            floatLabel="always">
            <mat-label>Email Address</mat-label>
            <input matInput type="email" #email="ngModel" name="email" [ngModel]="userProfile.email"
              [readonly]="!userId" required [maxlength]="UserMaxLen.email">
            <mat-error *ngIf="email.invalid && email.touched && email.dirty && email.errors?.['exists']">Email already
              exists</mat-error>
            <mat-error
              *ngIf="email.invalid && email.touched && email.dirty && email.errors?.['error']">{{email.errors?.['error']}}</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>{{stateService.userRole == UserRole.Agency_Attorney ? "Current Selected Agency" :
              firmNameLabel}}</mat-label>
            <input matInput type="text" name="nameOfFirm" [ngModel]="userProfile.firm_Name"
              [readonly]="userProfile.role_id != UserRole.Protester" required [maxlength]="UserMaxLen.firm_Name">
          </mat-form-field>

          <app-agency #agencies fxFlex="auto" (agencies)="onSelectedAgencies($event)" [tier2Required]="true"
            *ngIf="(userProfile.role_id == UserRole.Agency_Attorney || (userId && userProfile.role_id == UserRole.Agency_Admin) )"></app-agency>

          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always"
            *ngIf="userId && (userProfile.role_id == UserRole.Agency_Attorney || userProfile.role_id == UserRole.Agency_Admin)">
            <mat-label>Agency Role</mat-label>
            <mat-select fxFlex="auto" name="epds_role_id" [ngModel]="userProfile.role_id" required>
              <mat-option>Please Select Agency Role</mat-option>
              <mat-option *ngFor="let agencyRole of agencyRoles" [value]="agencyRole.id">
                {{agencyRole.label}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Phone Number</mat-label>
            <input matInput type="text" name="phoneNo" required [ngModel]="userProfile.phone_No"
              [maxlength]="UserMaxLen.phone_No">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Fax Number</mat-label>
            <input matInput type="text" name="faxNo" [ngModel]="userProfile.fax_No" [maxlength]="UserMaxLen.fax_No">
          </mat-form-field>
          <mat-form-field matTooltip="{{fieldTexts.companyAddToolTip}}" fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Address Line 1</mat-label>
            <input matInput type="text" name="address1" [ngModel]="userProfile.address1" required
              [maxlength]="UserMaxLen.address1" appGmapAutocom (selectedPlace)="fillAddressForm($event)">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Address Line 2</mat-label>
            <input matInput type="text" name="address2" [ngModel]="userProfile.address2"
              [maxlength]="UserMaxLen.address2">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Zip Code</mat-label>
            <input matInput type="text" name="zipCode" [ngModel]="userProfile.zip_Code" required
              [maxlength]="UserMaxLen.zip_Code">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>City</mat-label>
            <input matInput type="text" name="city" [ngModel]="userProfile.city" required [maxlength]="UserMaxLen.city">
          </mat-form-field>
          <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>State</mat-label>
            <input matInput type="text" name="state" [ngModel]="userProfile.state" required
              [maxlength]="UserMaxLen.state">
          </mat-form-field>
          <mat-form-field fxFlex="auto" fxFlex.lt-lg="auto" appearance="outline" floatLabel="always">
            <mat-label>Country</mat-label>
            <input matInput type="text" name="country" [ngModel]="userProfile.country" required
              [maxlength]="UserMaxLen.country">
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-checkbox required *ngIf="register" name="agreeStatement" [(ngModel)]="isChecked"><mat-label>I have reviewed and agree to abide by GAO's Bid Protest Regulations and EPDS Instructions,
        which are available here:
        <a href="https://www.gao.gov/legal/bid-protests/file-a-bid-protest" target="_blank">https://www.gao.gov/legal/bid-protests/file-a-bid-protest</a>
      </mat-label></mat-checkbox>
      <mat-card-actions fxLayoutAlign="center" fxLayoutGap="16px">
        <button color="primary" mat-raised-button type="submit" class="spinner-black"
          [disabled]="(register && !isChecked) || profileSaving || (!fProfile.dirty  && !agencyComponent?.form?.dirty) || fProfile.invalid || agencyComponent?.form?.invalid">
          <div *appSpinner="profileSaving"></div>
          Submit
        </button>
        <button *ngIf="!register" color="warn" mat-raised-button type="button" (click)="onCancel()">Cancel</button>
      </mat-card-actions>
        <mat-card-actions fxLayoutAlign="center" fxLayoutGap="16px">
        <mat-label *ngIf="register">
          <a href="javascript:void(0)" (click)="$event.preventDefault();onReturn();">Return to the login page</a>
        </mat-label>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
